import { Environment } from '@/enums/environment';
import { EnvironmentConfig } from '@/types';

const ENVIRONMENT_CONFIGS: Record<Environment, EnvironmentConfig> = {
    [Environment.LOCAL]: {
        VITE_API: 'https://api-dev.gls-group.net',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgrouptest.b2clogin.com/glsgrouptest.onmicrosoft.com',
        VITE_AZURE_B2C_CLIENT_ID: 'a0462fe1-7da4-4d67-883f-290bcbde8d39',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgrouptest.b2clogin.com',
        VITE_AZURE_AD_CLIENT_ID: '342c952f-c3ec-4368-893d-c96f8db19625'
    },
    [Environment.DEV]: {
        VITE_API: 'https://api-dev.gls-group.net',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgrouptest.b2clogin.com/glsgrouptest.onmicrosoft.com',
        VITE_AZURE_B2C_CLIENT_ID: 'a0462fe1-7da4-4d67-883f-290bcbde8d39',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgrouptest.b2clogin.com',
        VITE_AZURE_AD_CLIENT_ID: '342c952f-c3ec-4368-893d-c96f8db19625'
    },
    [Environment.STAGE]: {
        VITE_API: 'https://api-qas.gls-group.net',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgrouptest.b2clogin.com/glsgrouptest.onmicrosoft.com',
        VITE_AZURE_B2C_CLIENT_ID: 'a0462fe1-7da4-4d67-883f-290bcbde8d39',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgrouptest.b2clogin.com',
        VITE_AZURE_AD_CLIENT_ID: '342c952f-c3ec-4368-893d-c96f8db19625'
    },
    [Environment.PROD]: {
        VITE_API: 'https://api.gls-group.net',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgroup.b2clogin.com/glsgroup.onmicrosoft.com',
        VITE_AZURE_B2C_CLIENT_ID: '78df48dd-e52a-485f-8509-4ce68403660c',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgroup.b2clogin.com',
        VITE_AZURE_AD_CLIENT_ID: 'f73b84b3-21b3-4d73-942c-e5f7591548e3'
    }
};

export { ENVIRONMENT_CONFIGS };
